export const allAgendas = [
	[
		{
			"startDate": "2025-10-26T09:00:00+01:00",
			"endDate": "2025-10-26T10:00:00+01:00",
			"title": "Keynote: Serving up the secrets of success",
			"speaker": "Martina Navratilova",
			"room": "auditorium-one",
			"path": "/auditorium-one"
		},
		{
			"startDate": "2025-10-26T09:00:00+01:00",
			"endDate": "2025-10-26T10:00:00+01:00",
			"title": "Keynote: Serving up the secrets of success",
			"speaker": "Martina Navratilova",
			"room": "auditorium-two",
			"path": "/auditorium-two"
		},
		{
			"startDate": "2025-10-26T10:15:00+01:00",
			"endDate": "2025-10-26T11:00:00+01:00",
			"title": "Danger Zone: Where risk meets reward",
			"speaker": "Stuart Frost - UK Government",
			"room": "auditorium-one",
			"path": "/auditorium-one"
		},
		{
			"startDate": "2025-10-26T10:15:00+01:00",
			"endDate": "2025-10-26T11:00:00+01:00",
			"title": "Building Resilient Security Functions: Leveraging AI and fostering culture",
			"speaker": "Leonie Witte - Capgemini UK",
			"room": "auditorium-two",
			"path": "/auditorium-two"
		},
		{
			"startDate": "2025-10-26T11:30:00+01:00",
			"endDate": "2025-10-26T12:15:00+01:00",
			"title": "The Seven Most Essential OT Cyber Security Controls: A guide to success",
			"speaker": "Thomas Wegner - YARA",
			"room": "auditorium-one",
			"path": "/auditorium-one"
		},
		{
			"startDate": "2025-10-26T11:30:00+01:00",
			"endDate": "2025-10-26T12:15:00+01:00",
			"title": "Leadership in Cyber Security: Navigating communication across cultures",
			"speaker": "Patric J.M. Versteeg - Heerema Marine Contract",
			"room": "auditorium-two",
			"path": "/auditorium-two"
		},
		{
			"startDate": "2025-10-26T13:30:00+01:00",
			"endDate": "2025-10-26T14:15:00+01:00",
			"title": "Blue Lights and Breaches: Bridging the gap between cyber and emergency response for better incident management",
			"speaker": "Matt Palmer - Jersey Cyber Security Centre (JCS)",
			"room": "auditorium-one",
			"path": "/auditorium-one"
		},
		{
			"startDate": "2025-10-26T13:30:00+01:00",
			"endDate": "2025-10-26T14:15:00+01:00",
			"title": "Now \"What should we do?\": Evolving Hitachi Group's Information Security",
			"speaker": "Peter East - Hitachi Ltd / Neil Fowler Wright - Hit",
			"room": "auditorium-two",
			"path": "/auditorium-two"
		},
		{
			"startDate": "2025-10-26T14:30:00+01:00",
			"endDate": "2025-10-26T15:15:00+01:00",
			"title": "Hack the Mind: The power of storytelling in cyber and AI leadership",
			"speaker": "Carlo Schreurs - Frieslandcampina",
			"room": "auditorium-one",
			"path": "/auditorium-one"
		},
		{
			"startDate": "2025-10-26T14:30:00+01:00",
			"endDate": "2025-10-26T15:15:00+01:00",
			"title": "Bane NOR's Journey to a Strategic Goal-Oriented Security Metrics and CISO dashboard",
			"speaker": "Silje Fossåskaret - Bane NOR",
			"room": "auditorium-two",
			"path": "/auditorium-two"
		},
		{
			"startDate": "2025-10-26T15:45:00+01:00",
			"endDate": "2025-10-26T16:45:00+01:00",
			"title": "Keynote: Cyber Power: Navigating the age of cyber threats and opportunities",
			"speaker": "Sir Jeremy Fleming",
			"room": "auditorium-one",
			"path": "/auditorium-one"
		},
		{
			"startDate": "2025-10-26T15:45:00+01:00",
			"endDate": "2025-10-26T16:45:00+01:00",
			"title": "Keynote: Cyber Power: Navigating the age of cyber threats and opportunities",
			"speaker": "Sir Jeremy Fleming",
			"room": "auditorium-two",
			"path": "/auditorium-two"
		}
	],
	[
		{
			"startDate": "2025-10-27T09:00:00+01:00",
			"endDate": "2025-10-27T10:00:00+01:00",
			"title": "Keynote: Mind out of joint: Hacking the brain for success at work and life",
			"speaker": "Dr Helena Boschi",
			"room": "auditorium-one",
			"path": "/auditorium-one"
		},
		{
			"startDate": "2025-10-27T09:00:00+01:00",
			"endDate": "2025-10-27T10:00:00+01:00",
			"title": "Keynote: Mind out of joint: Hacking the brain for success at work and life",
			"speaker": "Dr Helena Boschi",
			"room": "auditorium-two",
			"path": "/auditorium-two"
		},
		{
			"startDate": "2025-10-27T10:15:00+01:00",
			"endDate": "2025-10-27T11:00:00+01:00",
			"title": "Your Security Team is Awesome: Why doesn't management know it?",
			"speaker": "Sebastian Avanvarei - Canon",
			"room": "auditorium-one",
			"path": "/auditorium-one"
		},
		{
			"startDate": "2025-10-27T10:15:00+01:00",
			"endDate": "2025-10-27T11:00:00+01:00",
			"title": "Building a Flexible Framework for Cyber Risk Management",
			"speaker": "John Hinchcliffe - Tesco Bank",
			"room": "auditorium-two",
			"path": "/auditorium-two"
		},
		{
			"startDate": "2025-10-27T11:30:00+01:00",
			"endDate": "2025-10-27T12:15:00+01:00",
			"title": "Improve your Resilience to Geopolitical Challenges Using Intelligence",
			"speaker": "James Kwaan - Lloyds banking group",
			"room": "auditorium-one",
			"path": "/auditorium-one"
		},
		{
			"startDate": "2025-10-27T11:30:00+01:00",
			"endDate": "2025-10-27T12:15:00+01:00",
			"title": "Building Supply Chain Security with Collaboration",
			"speaker": "Shara Teryung - JBT Marel / Ben Strijbosch - JBT Marel",
			"room": "auditorium-two",
			"path": "/auditorium-two"
		},
		{
			"startDate": "2025-10-27T13:30:00+01:00",
			"endDate": "2025-10-27T14:15:00+01:00",
			"title": "Maturing a Third-Party Risk Assessment by Leveraging the ISF SDGP and Supplier Security Tool",
			"speaker": "Emmerentia Du Plooy - Standard Bank Group / Ts...",
			"room": "auditorium-one",
			"path": "/auditorium-one"
		},
		{
			"startDate": "2025-10-27T13:30:00+01:00",
			"endDate": "2025-10-27T14:15:00+01:00",
			"title": "Unlocking the Power of Security Metrics: The hidden path to strategic insights",
			"speaker": "Antti Evesti - KPMG",
			"room": "auditorium-two",
			"path": "/auditorium-two"
		},
		{
			"startDate": "2025-10-27T14:30:00+01:00",
			"endDate": "2025-10-27T15:15:00+01:00",
			"title": "The BISO Journey: Implementing the BISO Role at PostNL",
			"speaker": "Dieudonnée Penning - PostNL",
			"room": "auditorium-one",
			"path": "/auditorium-one"
		},
		{
			"startDate": "2025-10-27T14:30:00+01:00",
			"endDate": "2025-10-27T15:15:00+01:00",
			"title": "Zero Trust? Zero Problems!",
			"speaker": "Charlotte Meyer - Giesecke+Devrient",
			"room": "auditorium-two",
			"path": "/auditorium-two"
		},
		{
			"startDate": "2025-10-27T15:45:00+01:00",
			"endDate": "2025-10-27T16:45:00+01:00",
			"title": "Keynote: Qubits, AI, & Robots: Adding to the security leader's playbook for the next decade",
			"speaker": "Jaya Baloo",
			"room": "auditorium-one",
			"path": "/auditorium-one"
		},
		{
			"startDate": "2025-10-27T15:45:00+01:00",
			"endDate": "2025-10-27T16:45:00+01:00",
			"title": "Keynote: Qubits, AI, & Robots: Adding to the security leader's playbook for the next decade",
			"speaker": "Jaya Baloo",
			"room": "auditorium-two",
			"path": "/auditorium-two"
		}
	],
	[
		{
			"startDate": "2025-10-28T09:00:00+01:00",
			"endDate": "2025-10-28T10:00:00+01:00",
			"title": "Keynote: Roles and regulations: The hidden human factors in mitigating risk",
			"speaker": "Tom Hardin",
			"room": "auditorium-one",
			"path": "/auditorium-one"
		},
		{
			"startDate": "2025-10-28T09:00:00+01:00",
			"endDate": "2025-10-28T10:00:00+01:00",
			"title": "Keynote: Roles and regulations: The hidden human factors in mitigating risk",
			"speaker": "Tom Hardin",
			"room": "auditorium-two",
			"path": "/auditorium-two"
		},
		{
			"startDate": "2025-10-28T10:15:00+01:00",
			"endDate": "2025-10-28T11:00:00+01:00",
			"title": "Implementing the Design Basis Threat Concept (DBT) in Non-Nuclear Fields",
			"speaker": "Timo Wonder - Elisa Oyj",
			"room": "auditorium-one",
			"path": "/auditorium-one"
		},
		{
			"startDate": "2025-10-28T10:15:00+01:00",
			"endDate": "2025-10-28T11:00:00+01:00",
			"title": "How Airbus used Scenario Planning to Identify Cyber Exposure (‘SPICE’) and Quantify Cyber Impact",
			"speaker": "Olivier Allaire - Airbus Protect",
			"room": "auditorium-two",
			"path": "/auditorium-two"
		},
		{
			"startDate": "2025-10-28T11:30:00+01:00",
			"endDate": "2025-10-28T12:30:00+01:00",
			"title": "Keynote: Sound advice: What businesses can learn from a symphony orchestra",
			"speaker": "Rainer Hersch",
			"room": "auditorium-one",
			"path": "/auditorium-one"
		},
		{
			"startDate": "2025-10-28T11:30:00+01:00",
			"endDate": "2025-10-28T12:30:00+01:00",
			"title": "Keynote: Sound advice: What businesses can learn from a symphony orchestra",
			"speaker": "Rainer Hersch",
			"room": "auditorium-two",
			"path": "/auditorium-two"
		}
	]
].flat().map(it => ({
	...it,
	style: {
		justifyContent: "flex-start"
	}
}))

export const breakout1Agenda = allAgendas.filter(event => event.room === "Breakout One")

export const breakout2Agenda = allAgendas.filter(event => event.room === "Breakout Two")

export const breakout3Agenda = allAgendas.filter(event => event.room === "Breakout Three")

export const breakout4Agenda = allAgendas.filter(event => event.room === "Breakout Four")

export const auditoriumAgenda = allAgendas.filter(event => event.room.startsWith("auditorium"))
export const auditoriumOneAgenda = allAgendas.filter(event => event.room === "auditorium-one")
export const auditoriumTwoAgenda = allAgendas.filter(event => event.room === "auditorium-two")